import React, { useCallback } from 'react';
import qs from 'qs-lite';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';

import { withRouter } from 'react-router-dom';
import { getQueryParamMap } from '../../../utils/query-params';
import { StyledTableCell, StyledTableSortLabel } from './styles';

const VpTableHeader = withRouter(({ history, onChange, headCells, meta }) => {
  const updateQueryString = useCallback((newQueryParams) => {
    const queryParamMap = {
      ...getQueryParamMap(history),
      ...newQueryParams
    };
    const searchString = `?${qs.stringify(queryParamMap)}`;
    history?.push(
      {
        pathname: history?.location?.pathname,
        search: searchString
      },
      { from: 'TABLE_HEADER_CHANGE' }
    );
    onChange && onChange();
  }, []);

  const createSortHandler = (id) => {
    const sortOrder = meta?.sortOrder === 'DESC' ? 'ASC' : 'DESC';
    updateQueryString({ orderBy: id, sortOrder });
  };

  return (
    <TableHead>
      <TableRow>
        {headCells?.map((cell) =>
          !cell?.sortable ? (
            <StyledTableCell centered={cell?.centered} key={cell?.id}>
              {cell?.label}
            </StyledTableCell>
          ) : (
            <StyledTableCell key={cell?.id} centered={cell?.centered}>
              <StyledTableSortLabel
                active={meta?.orderBy === cell.id}
                direction={meta?.orderBy === cell.id ? meta?.sortOrder?.toLowerCase() : 'desc'}
                onClick={() => createSortHandler(cell.id)}
              >
                {cell?.label}
              </StyledTableSortLabel>
            </StyledTableCell>
          )
        )}
        <TableCell padding="checkbox"></TableCell>
      </TableRow>
    </TableHead>
  );
});

export default VpTableHeader;



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpTableHeader/VpTableHeader.jsx